import moment, { isMoment } from 'moment';
import {
  // 时间筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import type { IDateTypely } from '../types/common';
import LeftTable from '@/pages/dashboard/pages/benchmark/components/CompareGameFilter/LeftTable';

// type IRangeTimeData = {
//   granularity: IDateTypely;
//   startDate: string;
//   endDate: string;
// };

// 不同时间粒度下的 开始时间获取方法
const DEFAULT_START_DATE_GETTERS: {
  [key in IDateTypely]: (endDate: string) => string;
} = {
  // 日粒度，开始时间为结束时间往前推30天
  daily: (endDate) => {
    const endDateM = checkDate(endDate);
    if (!endDateM) return '';
    return endDateM.subtract(30, 'days').format('YYYY-MM-DD');
  },
  // 周粒度，开始时间为结束时间往前推4个星期
  weekly: (endDate) => {
    const endDateM = checkDate(endDate);
    if (!endDateM) return '';
    return endDateM.startOf('week').subtract(4, 'weeks').format('YYYY-MM-DD');
  },
  // 月粒度，开始时间为结束时间往前推6个月
  monthly: (endDate) => {
    const endDateM = checkDate(endDate);
    if (!endDateM) return '';
    return endDateM.startOf('month').subtract(6, 'months').format('YYYY-MM-DD');
  },
  // 年粒度，开始时间为结束时间往前推3年
  yearly: (endDate) => {
    const endDateM = checkDate(endDate);
    if (!endDateM) return '';
    return endDateM.startOf('year').subtract(3, 'years').format('YYYY-MM-DD');
  },
};

const checkDate = (date: string): false | moment.Moment => {
  if (!date) return false;
  const dateM = moment(date);
  return dateM.isValid() ? dateM : false;
};

export const getStartDateByEndDate = (granularity: IDateTypely, endDate: string): string => {
  const startDateGetter = DEFAULT_START_DATE_GETTERS[granularity];
  if (!startDateGetter) return endDate || '';
  return startDateGetter(endDate);
};

export const handleSingleDate2RangeRangeTimeInFilterExtend = (filterExtend: any): any => {
  if (!filterExtend) return {};
  const rangeTime = filterExtend?.[RANGE_TIME_SELECT_FILTER] || {};
  const granularity = rangeTime?.granularity || 'daily';
  const endDate = rangeTime?.end_date || '';
  const startDate = getStartDateByEndDate(granularity, endDate);
  const startDateM = moment(startDate);
  let endDateM = rangeTime?.filterValue?.[1];
  endDateM = isMoment(endDateM) ? endDateM : moment(endDate);
  return {
    ...filterExtend,
    [RANGE_TIME_SELECT_FILTER]: {
      ...rangeTime,
      filterValue: [startDateM, endDateM],
      start_date: startDate,
      end_date: endDate,
    },
  };
};

export const changeMiniGameRankingsFormat = (topList: any, endDate: any, isEN = true, metricTypeList: any[]): any => {
  if (!Array.isArray(topList)) return topList;
  if (!Array.isArray(metricTypeList) && metricTypeList?.length < 3) return topList;
  const popularityObj = {
    last_date: endDate,
    list: [],
    name: metricTypeList[0],
  } as any;
  const bestsellerObj = {
    last_date: endDate,
    list: [],
    name: metricTypeList[1],
  } as any;
  const mostPlayedObj = {
    last_date: endDate,
    list: [],
    name: metricTypeList[2],
  } as any;

  topList?.forEach((item: any) => {
    let publisherValue = (isEN && item?.publisher_en) || item?.publisher;
    if (item?.source === 'douyin') {
      publisherValue = (isEN && item?.app_desc_en) || item?.app_desc;
    }
    const objValue = {
      ...item,
      name: (isEN && item?.app_name_en) || item?.app_name,
      cover: item?.app_cover,
      rank: item?.game_rank,
      publisher: publisherValue,
      minigame_genre: (isEN && item?.minigame_genre_en) || item?.minigame_genre,
      minigame_sub_genre: (isEN && item?.minigame_sub_genre_en) || item?.minigame_sub_genre,
      rankChange: item?.rank_change,
    } as any;
    if (item.minigame_type === metricTypeList[0] && popularityObj.list?.length < 10) {
      popularityObj.list.push(objValue);
    } else if (item.minigame_type === metricTypeList[1] && bestsellerObj.list?.length < 10) {
      bestsellerObj.list.push(objValue);
    } else if (item.minigame_type === metricTypeList[2] && mostPlayedObj.list?.length < 10) {
      mostPlayedObj.list.push(objValue);
    }
  });
  return [popularityObj, bestsellerObj, mostPlayedObj];
};

export const changeMiniGameRankingsMoreFormat = (topList: any): any => {
  if (!Array.isArray(topList)) return topList;
  const resList: any = [];
  topList?.forEach((item: any) => {
    const objValue = {
      ...item,
      name: item?.app_name,
      cover: item?.app_cover,
      rank: item?.game_rank,
      publisher: item?.publisher,
      publisher_addr: '',
      rankChange: item?.rank_change,
    } as any;
    resList.push(objValue);
  });
  return resList;
};

export const handleRangeDate2SingleDateRangeTimeFilterExtend = (filterExtend: any): any => {
  if (!filterExtend) return {};
  const rangeTime = filterExtend?.[RANGE_TIME_SELECT_FILTER] || {};
  const granularity = rangeTime?.granularity || 'daily';
  const date = rangeTime?.end_date || '';
  const startDateM = granularity !== 'weekly' ? moment(date) : moment(date).startOf('week');
  const endDateM = granularity !== 'weekly' ? moment(date) : moment(date).endOf('week');
  return {
    ...filterExtend,
    [RANGE_TIME_SELECT_FILTER]: {
      ...rangeTime,
      filterValue: [startDateM, endDateM],
      start_date: startDateM?.isValid() ? startDateM.format('YYYY-MM-DD') : '',
      end_date: endDateM?.isValid() ? endDateM.format('YYYY-MM-DD') : '',
    },
  };
};

export const handleRangeMiniGameMoreFilterExtend = (filterExtend: any): any => {
  if (!filterExtend) return {};
  const rangeTime = filterExtend?.[RANGE_TIME_SELECT_FILTER] || {};
  const granularity = 'daily';
  const date = rangeTime?.end_date || moment().format('YYYY-MM-DD');

  return {
    ...filterExtend,
    [RANGE_TIME_SELECT_FILTER]: {
      ...rangeTime,
      granularity,
      filterValue: [date, date],
      start_date: date,
      end_date: date,
    },
  };
};

export const formatDateStr = (date: string, formatter = 'YYYY-MM-DD'): string => {
  if (!date) return '';
  const dateM = moment(date);
  return dateM.isValid() ? dateM.format(formatter) : date;
};

interface IGranularityMomentHelper {
  amounts: string;
  dateType: string;
  format: string;
}

/**
 * granularity与日期粒度对应的moment工具的相关配置、包含加减日期的粒度、操作日期的粒度、粒度的format
 * amounts：用于add、subtract等操作的粒度单位
 * dateType：用于startOf、endOf等操作的粒度单位
 * format：用于format moment的格式
 */
export const GRANULARITY_MOMENT_HELPER_MAPPING: Record<IDateTypely, IGranularityMomentHelper> = {
  daily: {
    amounts: 'days',
    dateType: 'day',
    format: 'YYYY-MM-DD',
  },
  weekly: {
    amounts: 'weeks',
    dateType: 'week',
    format: 'YYYY-MM-DD',
  },
  monthly: {
    amounts: 'months',
    dateType: 'month',
    format: 'YYYY-MM',
  },
  yearly: {
    amounts: 'years',
    dateType: 'year',
    format: 'YYYY',
  },
};
